import React, { useState } from 'react';
import axios from 'axios';
import contactBG from '../../assets/img/contact/bg-5-1.jpg';

function Contactz() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    service: '',
    subject: '',
    message: ''
  });

  const [popupMessage, setPopupMessage] = useState('');
  const [showPopup, setShowPopup] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setPopupMessage('');
    try {
      const response = await axios.post(
        'https://ricgop.online/api/appointmentForm.php',
        formData
      );

      if (response.data.success) {
        setPopupMessage(response.data.success);
        setShowPopup(true);
        setFormData({
          name: '',
          email: '',
          phone: '',
          date: '',
          service: '',
          subject: '',
          message: ''
        });
      } else {
        setPopupMessage('Unexpected server response.');
        setShowPopup(true);
      }
    } catch (error) {
      setPopupMessage('Error booking appointment. Please try again.');
      setShowPopup(true);
    }
  };

  return (
    <div
      id="it-contact"
      className="it-contact-area it-contact-style-3 p-relative z-index grey-bg-2 pt-190 pb-140"
      style={{ backgroundImage: `url(${contactBG})` }}
    >
      <div className="it-contact-p p-relative">
        <div className="container">
          <div className="row align-items-end">
            <div className="col-xl-6 col-lg-6">
              <div className="it-contact-left">
                <div className="it-contact-title-box mb-20">
                  <h3 className="it-section-title text-white">
                    Prevention is better <br />
                    than cure
                  </h3>
                </div>
                <div className="it-contact-text">
                  <p className="mb-0 text-white">
                    Take charge of your heart health today—book your medical visit at RIC for expert care and a seamless experience.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-xl-6 col-lg-6">
              <div className="it-contact-from-wrap z-index">
                <div className="it-contact-title-box mb-50">
                  <span className="it-section-subtitle red-border">Why choose Us?</span>
                  <h3 className="it-section-title d-block">
                    Book Your Medical <br /> Visit Now.
                  </h3>
                </div>

                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-sm-6 col-12 mb-20">
                      <div className="it-contact-input-box">
                        <input
                          type="text"
                          placeholder="Full Name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12 mb-20">
                      <div className="it-contact-input-box">
                        <input
                          type="email"
                          placeholder="E-mail"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12 mb-20">
                      <div className="it-contact-input-box">
                        <input
                          type="tel"
                          placeholder="Phone Number"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12 mb-20">
                      <div className="it-contact-input-box">
                        <input
                          type="date"
                          name="date"
                          value={formData.date}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-12 mb-20">
                      <div className="it-contact-input-box">
                        <select
                          name="service"
                          value={formData.service}
                          onChange={handleChange}
                          required
                          className="form-control"
                          style={{
                            width: '100%',
                            height: '50px',
                            padding: '0 15px',
                            border: '1px solid #ddd',
                            borderRadius: '4px'
                          }}
                        >
                          <option value="">Select a Service</option>
                          <option value="primary-care">Primary Care</option>
                          <option value="speciality-care">Speciality Care</option>
                          <option value="emergency-care">Emergency Care</option>
                          <option value="surgical-services">Surgical Services</option>
                          <option value="mental-health">Mental Health Services</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-12 mb-20">
                      <div className="it-contact-input-box">
                        <input
                          type="text"
                          placeholder="Subject"
                          name="subject"
                          value={formData.subject}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-12 mb-30">
                      <div className="it-contact-input-box">
                        <textarea
                          placeholder="Message"
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                        ></textarea>
                      </div>
                    </div>
                  </div>

                  <button type="submit" className="it-btn-theme red-bg mr-35">
                    <span className="btn-wrap">
                      <span className="text-one">Book Appointment</span>
                      <span className="text-two">Book Appointment</span>
                    </span>
                  </button>
                </form>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-8 col-lg-8">
              <div className="it-contact-tel-wrap">
                <div className="it-contact-tel-box d-flex align-items-center mb-40">
                  <div className="it-contact-tel-icon">
                    <span>
                      <i className="flaticon-email"></i>
                    </span>
                  </div>
                  <div className="it-contact-tel-text">
                    <a href="mailto:info@ricgop.online">
                      Official Email : info@ricgop.online
                    </a>
                    <a href="mailto:complaints@ricgop.online">
                      Complaint Quries : complaints@ricgop.online
                    </a>
                  </div>
                </div>
                <div className="it-contact-tel-box d-flex align-items-center">
                  <div className="it-contact-tel-icon">
                    <span>
                      <i className="flaticon-call"></i>
                    </span>
                  </div>
                  <div className="it-contact-tel-text">
                    <a href="tel:+92-51-9281111-9">Telephone : +92-51-9281111-9</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div className="it-contact-bg"></div>
      </div>

      {/* ✅ Popup Message Modal */}
      {showPopup && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 10000
        }}>
          <div style={{
            backgroundColor: '#fff',
            padding: '30px 40px',
            borderRadius: '10px',
            boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
            textAlign: 'center'
          }}>
            <p style={{ marginBottom: '20px', fontSize: '18px', color: '#333' }}>
              {popupMessage}
            </p>
            <button
              onClick={() => setShowPopup(false)}
              style={{
                padding: '10px 20px',
                backgroundColor: '#e20000',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer'
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Contactz;
